<template>
    <el-card>
        <template #header>
            <content-header />
        </template>
        <el-row type="flex" justify="center">
            <lz-form
                ref="form"
                :get-data="getData"
                :submit="onSubmit"
                :form.sync="form"
                :errors.sync="errors"
                :edit-mode="editMode"
            >
                <el-form-item label="标识" required prop="slug">
                    <el-input v-model="form.slug" />
                </el-form-item>
                <el-form-item label="名称" required prop="name">
                    <el-input v-model="form.name" />
                </el-form-item>
                <el-form-item label="权限" prop="permissions">
                    <el-transfer
                        filterable
                        :filter-method="filterMethod"
                        filter-placeholder="搜索权限"
                        :titles="['待选', '已选']"
                        :button-texts="['移除', '选择']"
                        v-model="form.permissions"
                        :data="perms"
                        :props="{ key: 'id', label: 'name' }"
                    />
                </el-form-item>

                <el-form-item label="菜单" prop="vue_routers">
                    <tree-transfer
                        :title="title"
                        pid="parent_id"
                        :from_data="vue_router"
                        :array-to-tree="true"
                        :to_data="form.vue_routers"
                        :default-props="{ label: 'title' }"
                        @addBtn="add"
                        @removeBtn="remove"
                        :mode="mode"
                        height="540px"
                        filter
                        open-all
                    />
                </el-form-item>
            </lz-form>
        </el-row>
    </el-card>
</template>

<script>
import treeTransfer from "el-tree-transfer";
import LzForm from "@c/LzForm";
import {
    editAdminRole,
    updateAdminRole,
    storeAdminRole,
} from "@/api/admin-roles";
import { getAdminPerms } from "@/api/admin-perms";
import { getVueRouters } from "@/api/vue-routers";
import FormHelper from "@c/LzForm/FormHelper";

export default {
    name: "Form",
    components: {
        LzForm,
        treeTransfer,
    },
    mixins: [FormHelper],
    data() {
        return {
            title: ["待选", "已选"],
            mode: "transfer",
            form: {
                slug: "",
                name: "",
                permissions: [],
                vue_routers: [],
                menu: [],
            },
            errors: {},
            perms: [],
            vue_router: [],
        };
    },
    methods: {
        async getData() {
            const [{ data: permissions }, { data: vue_routers }] =
                await Promise.all([
                    getAdminPerms({ all: 1 }),
                    getVueRouters({ all: 1 }),
                ]);
            this.perms = permissions;
            this.vue_router = vue_routers;

            if (this.editMode) {
                const { data } = await editAdminRole(this.resourceId);
                data.permissions = data.permissions.map((i) => i.id);

                this.fillForm(data);
            }
        },
        // 切换模式 现有树形穿梭框模式transfer 和通讯录模式addressList
        changeMode() {
            if (this.mode == "transfer") {
                this.mode = "addressList";
            } else {
                this.mode = "transfer";
            }
        },
        // 监听穿梭框组件添加
        add(vue_router, vue_routers, obj) {
            // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
            // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表

            this.form.menu = vue_routers;
        },
        // 监听穿梭框组件移除
        remove(vue_router, vue_routers, obj, form) {
            // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
            // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表

            this.form.menu = vue_routers;
        },

        async onSubmit() {
            if (this.editMode) {
                await updateAdminRole(this.resourceId, this.form);
            } else {
                await storeAdminRole(this.form);
            }
        },
        filterMethod(query, item) {
            return item.name.indexOf(query) > -1;
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep {
    .el-transfer-panel__body {
        height: 300px;
    }

    .el-transfer-panel__list.is-filterable {
        height: 249px;
    }
}
</style>
